export default __webpack_public_path__ + "static/media/x.92ca28e9.mp4";